import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';

import Replays from 'components/UI/Replays/Replays';

const ReplaysStyled = withStyles(theme => ({
  root: {
  },
  pageTitle: {
    marginTop: theme.spacing(8),
    marginBottom: theme.spacing(16),
  },
  paperWrapper: {
    width: '100%',
    display: 'block',
    position: 'relative',
    '&:before': {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      content: "' '",
      // height: '160px',
      height: '230px',
      backgroundColor: theme.palette.primary.light,
      backgroundImage: 'url('+require('assets/images/header_replay.jpg')+')',
      backgroundSize: 'cover',
      backgroundPosition: '50% 50%',
      backgroundRepeat: 'no-repeat',
      zIndex: -1
    }
  },
}))(Replays);

export default ReplaysStyled;



// WEBPACK FOOTER //
// ./src/components/Replays/Replays.jsx